module.exports = __webpack_public_path__ + "media/stylesheets/images/strengths_img-f98c24a46caad66f2734553135601efd.jpg";